
export const editProductEndpoint = (productId: string) =>
 (`/api/product/${productId}`);

export const getProductEndpoint = () =>(`/api/product`);

export const getProductDetailsEndpoint = (productId: string) =>
 (`/api/product/${productId}`);

export const deleteProductEndpoint = (productId: string) =>
 (`/api/product/${productId}`);
export const addProductEndpoint = () => (`/api/product`);